/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import { useEffect, useRef } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useSubscriptionAccess } from "../context/SubscriptionAccessContext";
import { emitFeatureGate } from "./surfaces";

export default function AccessRouteGate({ surface, fallbackTo, children }) {
  const location = useLocation();
  const { authToken, isLoading, getSurfaceDecision } = useSubscriptionAccess();
  const decision = getSurfaceDecision(surface, { allowWhileLoading: false });
  const emittedRef = useRef("");

  useEffect(() => {
    if (!authToken || isLoading || decision.allowed || !decision.featureCode) {
      return;
    }
    const emissionKey = `${location.pathname}:${decision.featureCode}:${decision.reason || "feature_off"}`;
    if (emittedRef.current === emissionKey) {
      return;
    }
    emittedRef.current = emissionKey;
    emitFeatureGate(decision);
  }, [authToken, decision, isLoading, location.pathname]);

  if (!authToken) {
    return children;
  }

  if (isLoading) {
    return null;
  }

  if (decision.allowed) {
    return children;
  }

  return <Navigate to={fallbackTo || surface?.fallbackTo || "/dashboard"} replace state={{ from: location }} />;
}